import { GraphQL } from "@rpi/openapi-api";

export const orderSearchLabels: Partial<Record<GraphQL.OrderSearchField, string>> = {
  customerPublicId: "Organizations",
  status: "Order Status",
  paymentStatus: "Payment Status",
  createdAt: "Order Date",
  updatedAt: "Status Updated Date",
  submittedAt: "Print Date",
};

function dateRender(value: string) {
  return new Date(value).toLocaleDateString();
}

export const orderSearchRenderers: Partial<Record<GraphQL.OrderSearchField, (value: string) => string>> = {
  createdAt: dateRender,
  updatedAt: dateRender,
  submittedAt: dateRender,
  status: (value) => publicOrderStatusRender(value as GraphQL.PublicOrderStatus),
  paymentStatus: (value) => paymentStatusRender(value as GraphQL.PaymentStatus),
};

const orderStatusFriendlyNames: Record<GraphQL.PublicOrderStatus, string> = {
  CANCELLATION_REQUESTED: "Cancellation Requested",
  CANCELLED: "Cancelled",
  EXCEPTION: "Exception",
  FAILED: "Failed",
  PRINTING: "Printing",
  QUEUED: "Queued",
  RECEIVED: "Received",
  REJECTED: "Rejected",
  SHIPPED: "Shipped",
  VALIDATING: "Validating",
  VALID_AWAITING_PAYMENT: "Valid - Awaiting Payments",
  VALID_HOLDING_BIN: "Valid - Holding Bin",
};

export function publicOrderStatusRender(value: GraphQL.PublicOrderStatus) {
  return orderStatusFriendlyNames[value];
}

const paymentStatusFriendlyNames: Record<GraphQL.PaymentStatus, string> = {
  EXTERNALLY_PAID: "Externally Paid",
  NO_PAYMENT_STAFF_ORDER: "No Payment - Staff Order",
  PAID: "Paid",
  PAYMENT_PENDING: "Payment Pending",
  UNPAID: "Unpaid",
};

export function paymentStatusRender(value: GraphQL.PaymentStatus) {
  return paymentStatusFriendlyNames[value];
}

const transactionTypeFriendlyNames: Record<GraphQL.TransactionType, string> = {
  REFUND: "Refund",
  SALE: "Sale",
  VOID: "Void",
};

export function transactionTypeRender(value: GraphQL.TransactionType) {
  return transactionTypeFriendlyNames[value];
}

export const paymentSearchLabels: Partial<Record<GraphQL.PaymentSearchFields, string>> = {
  customerPublicId: "Organizations",
  createdAt: "Payment Date",
  transactionType: "Transaction Types",
};

export const paymentSearchRenderers: Partial<Record<GraphQL.PaymentSearchFields, (value: string) => string>> = {
  createdAt: dateRender,
  transactionType: (value) => transactionTypeRender(value as GraphQL.TransactionType),
};
